import React, { useState, useEffect } from "react";
import { ThemeProvider, theme, ImageGallery } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import LeftSvg from "../../Icons/LeftSvg";
import RightSvg from "../../Icons/RightSvg";

const newTheme = {
  ...theme,
  variants: {},
};

export default function ImagePreviewSlider(props: any) {
  const [gallaryContent, setGalleryContent] = useState([]);
  const getImages = () => {
    const content = props.property_images.map((item: any) => {
      return {
        image: `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${item.key_path}?w=600&h=400&auto=format`,
        thumbnail: `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${item.key_path}?w=144&auto=format`,
      };
    });

    setGalleryContent(content);
  };

  useEffect(() => {
    getImages();
  }, []);
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative z-50 h-full shadow-sm flex flex-col justify-between">
        <div className="flex justify-between bg-black items-center px-4 py-3 text-xs text-gray-300">
          <div>Asset ID: 534839</div>
          <div className="cursor-pointer" onClick={() => props.onAction("no")}>
            <XIcon className="h-4 w-4" aria-hidden="true" />
          </div>
        </div>

        <ImageGallery
          images={gallaryContent}
          interval={0}
          width={600}
          height={400}
          gallerySliderBaseClasses={{
            imageActive: "scale-110",
            backgroundColor: "bg-black",
            height: "h-44",
          }}
          galleryBaseClasses={{
            wrapper: "h-full flex flex-col justify-between",
            display: "h-full flex justify-center items-center mt-11",
            height: "h-[400px]",
            width: "w-[600px]",
            margin: "mx-auto",
          }}
          galleryArrowBaseClasses={{
            size: "w-10 h-10",
            textStyle: "text-blue-700 text-3xl",
            left: "left-64",
            right: "right-64",
          }}
          renderArrowLeft={(props: any) => (
            <div
              className="absolute cursor-pointer bottom-[45%] left-64"
              onClick={props.handlePrev}
            >
              <LeftSvg />
            </div>
          )}
          renderArrowRight={(props: any) => (
            <div
              className="absolute cursor-pointer bottom-[45%] right-64"
              onClick={props.handleNext}
            >
              <RightSvg />
            </div>
          )}
        />
      </div>
    </ThemeProvider>
  );
}
